import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUpload = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Upload_b",
		children: /* @__PURE__ */ _jsx("path", {
			id: "fa-solid fa-upload",
			d: "M11.0229 5.32752V13.0657C11.0229 13.6412 10.5435 14.0889 10.0002 14.0889C9.42489 14.0889 8.97745 13.6412 8.97745 13.0657V5.32752L6.61239 7.66176C6.22887 8.07745 5.55771 8.07745 5.17418 7.66176C4.7587 7.27805 4.7587 6.60656 5.17418 6.22285L9.26509 2.12994C9.64861 1.71425 10.3198 1.71425 10.7033 2.12994L14.7942 6.22285C15.2097 6.60656 15.2097 7.27805 14.7942 7.66176C14.4107 8.07745 13.7395 8.07745 13.356 7.66176L11.0229 5.32752ZM3.86381 13.0657H7.95472C7.95472 14.2168 8.84961 15.1121 10.0002 15.1121C11.1188 15.1121 12.0456 14.2168 12.0456 13.0657H16.1365C17.2551 13.0657 18.182 13.993 18.182 15.1121V16.1354C18.182 17.2865 17.2551 18.1818 16.1365 18.1818H3.86381C2.71325 18.1818 1.81836 17.2865 1.81836 16.1354V15.1121C1.81836 13.993 2.71325 13.0657 3.86381 13.0657ZM15.6252 16.3912C16.0407 16.3912 16.3922 16.0714 16.3922 15.6237C16.3922 15.2081 16.0407 14.8563 15.6252 14.8563C15.1777 14.8563 14.8581 15.2081 14.8581 15.6237C14.8581 16.0714 15.1777 16.3912 15.6252 16.3912Z",
			fill: "#282A33"
		})
	})
});
export default SvgUpload;
